import React, {ReactElement} from 'react';
import './AudioFileComponentStyles.scss';
interface AudioFileComponentprops {
  src: string;
  className: any;
  transcribe: any;
}

const AudioFileComponent = (props: AudioFileComponentprops): ReactElement => {
  const {src, className, transcribe} = props;
  return (
    <div
      className={
        transcribe !== null
          ? 'audio-voice-mail-styles'
          : 'audio-web-hook-styles'
      }>
      <audio
        src={src}
        className={className}
        controls
        controlsList="nodownload noplaybackrate"
      />
    </div>
  );
};

export default AudioFileComponent;
